import moment from "moment";
import {
  TableCellType,
  TableHeader,
} from "../../../../components/custom-table/table";
import { AuthStatusOptionModel } from "../../../../data-model/authStatusOptions";
import {
  JCodeDetails,
  MedicalPaOrder,
} from "../../../../data-model/medicalPaOrdersModel";
import { TableCellWithColoredText } from "../../../../data-model/tableCells";
import { getAuthStatusOfOneJCode } from "../../../../utils/getAuthStatusOfMedicalPaOrder";

export enum CptCodesTableColumnKeys {
  CPT_CODE = "cptCode",
  CPT_DESCRIPTION = "cptDescription",
  STATUS = "authStatus",
  START_DATE = "startDate",
}

export interface CptCodeTabledata {
  [CptCodesTableColumnKeys.CPT_CODE]: string;
  [CptCodesTableColumnKeys.CPT_DESCRIPTION]: string;
  [CptCodesTableColumnKeys.STATUS]: TableCellWithColoredText;
  [CptCodesTableColumnKeys.START_DATE]: string;
}

export const cptTableHeader: TableHeader[] = [
  {
    label: "CPT Code",
    key: CptCodesTableColumnKeys.CPT_CODE,
    width: 20,
    order: 1,
    type: TableCellType.STRING,
    sortable: true,
  },

  {
    label: "Status",
    key: CptCodesTableColumnKeys.STATUS,
    width: 20,
    order: 3,
    type: TableCellType.BADGE,
    sortable: true,
  },
  {
    label: "CPT Description",
    key: CptCodesTableColumnKeys.CPT_DESCRIPTION,
    width: 60,
    order: 2,
    type: TableCellType.STRING,
    sortable: true,
  },
  {
    label: "Start Date",
    key: CptCodesTableColumnKeys.START_DATE,
    width: 20,
    order: 4,
    type: TableCellType.DATE,
    sortable: true,
  },
];

export const createCptCodesTableData = (
  order?: MedicalPaOrder,
  authStatusOptions?: AuthStatusOptionModel[],
) => {
  if (!order) {
    return [];
  }

  const authEntries = order?.auth_on_file?.auth_entries ?? [];
  const getAllJCodesData = () => {
    let JcodesData: JCodeDetails[] = [];
    authEntries.forEach((item) => {
      JcodesData.push(...(item?.j_codes ?? []));
    });
    return JcodesData;
  };
  const JcodesData = getAllJCodesData();
  return JcodesData.map((item, index) => {
    const authStatus = getAuthStatusOfOneJCode(item, authStatusOptions ?? []);

    return {
      [CptCodesTableColumnKeys.CPT_CODE]: item?.j_code ?? "",
      [CptCodesTableColumnKeys.CPT_DESCRIPTION]: item?.description ?? "",
      [CptCodesTableColumnKeys.STATUS]: {
        text: authStatus?.text,
        color: authStatus?.textColor,
        bgColor: authStatus?.bgColor,
      },

      [CptCodesTableColumnKeys.START_DATE]:
        moment(order?.created_at).format("MM/DD/YYYY") ?? "",
    };
  });
};
